import useDarkMode from '../../../hooks/useDarkMode';
import ServeIQLoader from './serveiqLoader';

/** Full-viewport loader (login, token bootstrap, and similar flows). Prefer `gridSectionLoader` for list and form regions. */
const Preloader = () => {
  const isDarkMode = useDarkMode();

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <ServeIQLoader size={80} />
    </div>
  );
};

export default Preloader;
